import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import { trackEvent } from '../helpers';

import ContactActions from '../actions/contact';

import Button from './Button';
import ContactForm from './ContactForm';

const Modal = withReactContent(Swal);

const ContactedLabel = styled.span`
  padding-left: 22px;
`;

const ModalHeader = styled.h1`
  border-bottom: solid 1px #e9e9e9;
  padding: 18px 10px 0;
  margin: 0 0 18px;
  text-align: left;
  font-size: 28px;
  width: 470px;
`;

const Tick = styled.span`
  border-right: solid 3px ${p => p.theme.body.color};
  border-bottom: solid 3px ${p => p.theme.body.color};
  display: inline-block;
  height: 15px;
  position: absolute;
  transform: rotate(45deg) translate(-16px, 14px);
  width: 8px;
`;

export default function EnquiryButton({ vendorId, type, location, userId }) {
  const dispatch = useDispatch();
  const isPreviouslyContacted = useSelector(s => {
    return !!(s.contact.message_history && s.contact.message_history[vendorId]);
  });

  const handleClick = ({ userId, vendorId }) => {
    dispatch(ContactActions.setMessageBox(false));
    window.scrollTo({
      top: 999999,
      left: 0,
      behavior: 'smooth',
    });
    trackEvent({
      event: 'click-enquire-cta',
      userId,
      vendorId,
    });
    // Modal.fire({
    //   title: <ModalHeader>Get in touch</ModalHeader>,
    //   html: <ContactForm vendorId={vendorId} wedding_date={wedding_date} />,
    //   allowOutsideClick: false,
    //   showCloseButton: true,
    //   allowEscapeKey: false,
    //   showConfirmButton: false,
    // });
  };

  return (
    <Button
      onClick={() => {
        handleClick({ userId, vendorId, type, location });
      }}
      type={isPreviouslyContacted ? 'text' : 'primary'}
    >
      {isPreviouslyContacted ? (
        <ContactedLabel>
          <Tick /> Contacted
        </ContactedLabel>
      ) : (
        'Send an enquiry'
      )}
    </Button>
  );
}
